<template>
  <LayoutContent>
    <div v-if="loading" class="text-center" style="margin-top: 20%">
      <v-progress-circular indeterminate color="primary"></v-progress-circular>
    </div>
    <div v-else>
      <v-container class="d-flex flex-column align-center" v-if="salon">
        <h1 class="primary--text text--darken-1">{{ salon.branch_name }}</h1>
        <Rating :value="salon.rate_number" class="mb-6" large dense customStar />
        <div class="stylist-roster w-100">
          <div class="d-inline-flex flex-column align-center" v-for="stylist in salon.stylist" :key="stylist.id">
            <StylistWithRating :stylist="stylist" type="salon" />
          </div>
        </div>
      </v-container>
      <section class="salon-reviews px-10 py-16 d-flex flex-column" :style="{ backgroundImage: `url(${background})` }">
        <v-container v-if="salon">
          <vue-masonry-wall :items="isShowMore ? newReviews : newReviews.slice(0, 20)" :options="{ width: 300, padding: 12 }">
            <template v-slot:default="{ item }">
              <v-card height="100%" class="pt-1 pb-1">
                <v-card-text class="d-flex flex-column justify-space-between">
                  <div v-if="item.branch_comment" class="mb-3">
                    <p class="font-weight-bold text-subtitle-1">{{ $t('label.store') }} - {{ salon.branch_name }}</p>
                    <p class="font-weight-regular text-body-2 mb-4">{{ item.branch_comment }}</p>
                  </div>
                  <div v-for="review in item.stylist" :key="review.id" class="mb-3">
                    <p class="font-weight-bold text-subtitle-1">{{ $t('label.stylist') }} - {{ review.staff_name }}</p>
                    <p class="font-weight-regular text-body-2 mb-4">{{ review.staff_comment }}</p>
                  </div>
                  <div>
                    <p class="font-weight-bold">{{ item.full_name }}</p>
                    <p class="font-weight-medium">{{ item.date | shortDate }}</p>
                  </div>
                </v-card-text>
              </v-card>
            </template>
          </vue-masonry-wall>
        </v-container>
        <app-button v-if="!isShowMore && newReviews.length > 20" :label="$t('button.loadMore')" gradient invert class="ma-auto mt-8 text-subtitle-1 px-10 py-5" @click="isShowMore = true" />
      </section>
    </div>
  </LayoutContent>
</template>

<script>
import { mapActions } from 'vuex'
import LayoutContent from '@/views/layouts/LayoutContent.vue'
import Rating from '@/components/Rating.vue'
import StylistWithRating from '@/components/StylistWithRating.vue'
import VueMasonryWall from 'vue-masonry-wall'
import { REVIEW } from '@/api'

export default {
  name: 'SalonInfoDetails',
  components: {
    LayoutContent,
    Rating,
    StylistWithRating,
    VueMasonryWall
  },
  data: () => ({
    loading: false,
    salon: null,
    background: 'https://images.pexels.com/photos/853427/pexels-photo-853427.jpeg?auto=compress&cs=tinysrgb&dpr=3&h=750&w=1260',
    reviews: [],
    newReviews: [],
    isShowMore: false
  }),
  methods: {
    ...mapActions('common', ['getStoreDetails'])
  },
  mounted() {
    this.loading = true
    REVIEW.getReviewList({ type: 2, item_id: this.$route.params.salonId }).then((res) => {
      let storeReviewList = res.review.filter((f) => f.comment !== '')
      let structuredArr = []
      if (storeReviewList.length > 0)
        storeReviewList.forEach((f) => {
          let arrBody = {
            date: f.date,
            full_name: f.full_name,
            branch_comment: f.comment
          }
          structuredArr.push(arrBody)
        })
      this.newReviews = this.newReviews.concat(structuredArr)
    })
    this.getStoreDetails({ storeId: this.$route.params.salonId })
      .then((res) => {
        this.salon = res
        this.background = res.image[0].image
        let newArr = []
        res.stylist.forEach((f) => {
          let stylistReviewList = f.review.filter((f) => f.comment !== '')
          if (stylistReviewList.length > 0)
            stylistReviewList.forEach((g, i) => {
              let arrBody = {
                date: g.date,
                full_name: g.full_name,
                stylist: [{ staff_name: f.name, staff_comment: g.comment }]
              }
              newArr.push(arrBody)
            })
        })
        this.newReviews = this.newReviews.concat(newArr)
        this.newReviews = this.newReviews.sort((a, b) => new Date(b.date) - new Date(a.date))
      })
      .finally(() => (this.loading = false))
  }
}
</script>

<style lang="scss" scoped>
.stylist-roster {
  gap: 1rem;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));
  justify-items: center;
}

.salon-reviews {
  // columns: 4;
  // column-gap: 6rem;

  position: relative;
  background-position: top;
  min-height: 80vh;

  &::before {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-image: linear-gradient(to bottom, transparent 20%, var(--v-background-base) 50%);
    content: '';
  }
}
</style>
